import { Header, Message, Segment } from 'semantic-ui-react';
import styled from 'styled-components';

export const StyledSegment = styled(Segment)`
height: 128px !important;
display: flex;
align-items: center;
width: -webkit-fill-available;
min-width: 150px;
 .column {
   width: 40% !important;
   white-space: nowrap !important;
 }
 .row {
   padding-top: 0.5em !important;
   padding-bottom: 0.5em !important;
 }
`

export const ResultsChartsWrapper = styled.div`
display: flex;
align-items: center;
gap: 25px;
flex-wrap: wrap;
margin-top: 3em;
`
export const StyledHeader = styled(Header)`
display: flex;
justify-content: space-between;
 .title {
  font-size: 16px !important;
 }
align-items: center;
`
export const StyledColumnValue = styled.div`
width: fit-content;
margin-left: 30px;
`
export const StyledInformationWrapper = styled.div`
height: 400px !important;
.column div {
  font-size: 15px !important;
  }
 .ui.icon.button {
  padding: 7px; 
 }
  .segment {
    min-width: 300px;
    max-width: 350px;
    padding: 0.5em 0.5em !important;
  }
  .ui.attached.segment {
    height: 440px;
    max-height: 440px;
   }

 .label {
  font-size: 16px !important;
  left: -1.1rem !important;
  margin-right: -1.2em;
  padding-left: calc(1rem + 1.2em);
  padding-right: 1.2em;
  top: 30px;
  background: rgb(116, 196, 4);
  color: white;
  margin-left: 0px;
  z-index: 99;
}
`
export const StyledEmissionWrap = styled.div`
width: 30%;
height: 400px;
  .segment {
    width: 300px;
    min-width: 300px;
    max-width: 420px;
    padding: 0.5em 0.5em !important;
    border-radius: 5px !important;
  }
  .ui.attached.segment {
    height: 440px;
    max-height: 440px;
    display: flex;
    align-items: center;
    justify-content: center;
   }
`

export const CardStyled = styled.div`
border: 1px solid rgba(255, 255, 255, 0.2);
box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
border-radius: var(--radius);
padding: 1.5rem;
border-radius: 10px;
`
export const TooltipWrapper = styled.div`
margin: 0;
border: 1px solid #f5f5f5;
background-color: #f3f4f5;
border-radius: 5px;
padding: 5px;
z-index: 9999 !important;
min-width: 330px;
`
export const StyledMessage = styled(Message)`
height: 38px !important;
padding: 0.5em 1em !important;
margin-right: auto !important;
margin-left: auto !important;
`